import './FiltersModal.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../../../../design/modals/modal/S_Modal';
import { IImageFilters, IImageFiltersData } from '../../imageFilters.model';
import { AnnotatedByFilterInfo } from './annotatedBy/AnnotatedByFilterInfo';
import { AnnotationToolsFilterInfo } from './annotationTools/AnnotationToolsFilterInfo';
import { CorrectedFilterInfo } from './corrected/CorrectedFilterInfo';
import { ImageNameFilterInfo } from './ImageNameFilterInfo';
import { ImageSetFilterInfo } from './imageSet/ImageSetFilterInfo';
import { InDatasetsFilterInfo } from './inDatasets/InDatasetsFilterInfo';
import { ReviewedByFilterInfo } from './reviewdBy/ReviewedByFilterInfo';
import { SortingFilterInfo } from './sorting/SortingFilterInfo';
import { StatusFilterInfo } from './status/StatusFilterInfo';

interface IFiltersIconProps {
  availableFilters: IImageFiltersData;
  imageFilters: IImageFilters;
  isOpen: boolean;
  toggle: () => void;
}

export const FiltersModal = observer((props: IFiltersIconProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      className='filter-modal'
      headerText={t('image_filters.active_filters')}
    >
      <div className='filter-modal-list'>
        <ImageNameFilterInfo {...props} />
        <InDatasetsFilterInfo {...props} />
        <AnnotatedByFilterInfo {...props} />
        <ReviewedByFilterInfo {...props} />
        <StatusFilterInfo {...props} />
        <AnnotationToolsFilterInfo {...props} />
        <ImageSetFilterInfo {...props} />
        <CorrectedFilterInfo {...props} />
        <SortingFilterInfo {...props} />
      </div>
    </S_Modal>
  );
});
